import React, { useEffect, useState, useRef } from 'react';
import { motion } from "framer-motion";
import logisticsImg from "../assets/logistics.webp"; // 📌 Replace with your actual image
import clockImg from "../assets/clock-delivery.png";
import chartImg from "../assets/efficiency-growth.webp";
import { Helmet } from "react-helmet-async";
import customerImg from "../assets/customer-satisfaction.png";
import big from "../assets/Big.webp";
import tick from "../assets/Tick.svg";
import illustration from "../assets/tracking-benefits.webp";
import k1 from "../assets/K1.png";
import k2 from "../assets/K2.png";
import k3 from "../assets/K3.png";
import k4 from "../assets/K4.png";

const Logistics = () => {
  
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // 3s delay
    return () => clearInterval(timer);
  }, []);

  const words = ['logistics', 'freight management'];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000); // 1.4s display + 0.6s scroll

    return () => clearInterval(interval);
  }, []);

  // const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        // setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const benefitss = [
    {
      title: "Real-Time Visibility",
      description:
        "Our real-time tracking and monitoring technologies guarantee that businesses are always aware of the location, status and condition of their shipments.",
      image: clockImg,
    },
    {
      title: "Operational Efficiency",
      description:
        "These efficiency advantages are essential in today's competitive market climate, where dependability, speed and cost-effectiveness are critical factors.",
      image: chartImg,
    },
    {
      title: "Customer Satisfaction",
      description:
        "Our tracking projects ensure companies meet tight delivery deadlines, provide accurate arrival times and resolve logistical issues quickly.",
      image: customerImg,
    },
  ];

  const transformationDrivers = [
    {
      title: "Digitalization",
      icon: k1,
      description:
        "Digital technologies like automation, AI and data analytics enhance logistics by improving decision-making, real-time tracking and supply chain management.",
    },
    {
      title: "Automation",
      icon: k2,
      description:
        "Automation, including robotics and self-driving cars, is transforming logistics by reducing errors and increasing operational efficiency in warehouses.",
    },
    {
      title: "Sustainability",
      icon: k3,
      description:
        "Environmental concerns and regulations drive logistics to adopt sustainable practices like electric vehicles, reusable packaging and route optimization.",
    },
    {
      title: "Globalization",
      icon: k4,
      description:
        "Global expansion drives demand for international logistics, requiring real-time visibility, compliance and smarter coordination across borders.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // change every 3s
    return () => clearInterval(interval);
  }, []);

  const FeatureCard = ({ title, items, bgColor, dotColor }) => (
    <div className={`rounded-2xl p-6 shadow-sm ${bgColor} w-full max-w-md`}>
      <h3 className="font-semibold text-xl mb-4 text-gray-900">{title}</h3>
      <ul className="space-y-3">
        {items.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <span className={`mt-1 w-2.5 h-2.5 rounded-full ${dotColor}`}></span>
            <span className="text-sm text-gray-800 leading-snug">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  const cardRefs = useRef([]);
  const [visible, setVisible] = useState([]);

  /* observe cards on scroll (in AND out) */
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const i = +e.target.dataset.index;
          if (e.isIntersecting) {
            // add index if not already there
            setVisible((prev) => (prev.includes(i) ? prev : [...prev, i]));
          } else {
            // remove index so the animation can run again next time
            setVisible((prev) => prev.filter((v) => v !== i));
          }
        });
      },
      { threshold: 0.15 }
    );

    cardRefs.current.forEach((el) => el && io.observe(el));
    return () => io.disconnect();
  }, []);

  const variants = {
    hiddenLeft: { opacity: 0, x: -80 },
    hiddenRight: { opacity: 0, x: 80 },
    hiddenUp: { opacity: 0, y: -80 },
    hiddenDown: { opacity: 0, y: 80 },
    show: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const logisticsBenefits = [
    {
      title: "Enhanced Efficiency",
      description:
        "Automation and digital tools are cutting down on operational expenses, expediting workflows and eliminating delays. Deliveries become quicker and more dependable as a result, which is advantageous for both customers and companies.",
    },
    {
      title: "Enhanced Visibility",
      description:
        "Businesses are able to watch the flow of goods, anticipate disruptions and make well-informed decisions to reduce risks thanks to real-time tracking and data analytics, which offer a better understanding of the supply chain.",
    },
    {
      title: "Customer Experience",
      description:
        "Businesses can provide better customer service, such as precise delivery dates, adaptable shipping alternatives and quicker answers to queries, by implementing more transparent and efficient logistics processes.",
    },
    {
      title: "Sustainable Practices",
      description:
        "Digital logistics promotes eco-friendly practices, such as route optimization and reduced fuel consumption, helping companies reduce their carbon footprint and align with global sustainability goals.",
    },
  ];

  return (

    <div >
      <Helmet>
        <title>Supply Chain & Logistics Solutions | Real-Time Tracking & Operational Efficiency</title>
        <meta name="description" content="MAWALOG adapts to every industry, delImprove visibility, enhance operational efficiency, reduce costs and deliver superior customer experiences through real-time tracking, automation, digitalization and sustainable practices. " />

        <meta name="keywords" content=" LENTERA logistics services, logistics visibility, customer-centric logistics, global supply chain management. " />
      </Helmet>

      <section className="bg-[#E0FFE9] font-poppins w-full">
        <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 px-6 py-16">
          {/* Text Section */}
          <div className="w-full md:w-6/12 text-center md:text-left">
            <p className="text-xs sm:text-sm font-semibold tracking-widest text-gray-900 mb-2">
              SUPPLY CHAIN & LOGISTICS
            </p>

            <h1 className="mb-6 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Redefining the future
              <br />
              of{" "}
              <span className="inline-block h-[70px] overflow-hidden relative align-middle">
                <div
                  className="transition-transform duration-[600ms] ease-in-out"
                  style={{ transform: `translateY(-${index * 70}px)` }}
                >
                  {words.map((word, i) => (
                    <div
                      key={i}
                      className="h-[70px] flex items-center text-[#07862B] text-[32px] sm:text-[42px] md:text-[48px] font-bold"
                    >
                      {word}
                    </div>
                  ))}
                </div>
              </span>
            </h1>

            <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
              Third-party integration uses external services and APIs to streamline
              supply chains. In today’s fast-changing logistics industry, digital
              transformation is essential.
            </p>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-6/12 flex justify-center">
            <img
              src={big}
              alt="Global logistics illustration"
              className="w-[90%] max-w-[400px] sm:max-w-[500px] md:max-w-[560px]"
            />
          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
        {/* Top Heading and Paragraph */}
        <div className="max-w-[800px] mx-auto text-center mb-14">
          <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
            Advanced tracking in supply
            <br className="hidden sm:block" /> chain efficiency
          </h2>
          <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
            Advanced tracking uses technology to monitor and optimize supply chains.
            <br className="hidden md:block" />
            It improves visibility, cuts delays and reduces costs.
          </p>
        </div>

        {/* Card Grid */}
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefitss.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="flex flex-col items-center text-center border border-[#d3e1f6] rounded-[24px] bg-white p-8 shadow-sm hover:shadow-md transition-all min-h-[460px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-[348px] h-[208px] object-contain mb-6"
              />
              <h3 className="text-[20px] font-semibold text-[#1E1E1E] mb-4 leading-tight">
                {item.title}
              </h3>
              <p className="text-[#4B5563] text-[16px] leading-[26px]">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="w-full bg-[#1A1A1A] text-white px-4 py-16 sm:px-6 md:px-10 lg:px-24 font-[Poppins]">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left Section */}
          <div>
            <button className="bg-black text-white text-sm font-semibold px-5 py-1.5 rounded-full mb-5">
              BENEFITS OVERVIEW
            </button>

            <h2 className="text-3xl sm:text-4xl md:text-[42px] font-bold leading-tight mb-6">
              Benefits of our tracking <br /> projects
            </h2>

            <p className="text-gray-300 text-base leading-relaxed mb-10">
              Our tracking initiatives provide a number of game-changing advantages that are essential for contemporary freight and logistics management:
            </p>

            {/* Fixed 3x2 Badge Layout — responsive adjustment only */}
            <div className="flex flex-col gap-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex items-center gap-2 bg-[#3A3A3A] px-7 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Enhanced visibility and transparency
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-[#3A3A3A] px-7 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Improved efficiency and productivity
                  </span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex items-center gap-2 bg-[#3A3A3A] px-6 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Cost savings
                  </span>
                </div>
                <div className="flex items-center gap-4 bg-[#3A3A3A] px-6 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Better customer services
                  </span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex items-center gap-2 bg-[#3A3A3A] px-5 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Enhanced security
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-[#3A3A3A] px-5 py-2.5 rounded-full ">
                  <img src={tick} alt="tick" className="w-5 h-5" />
                  <span className="font-semibold text-white text-sm whitespace-nowrap">
                    Data-driven insights
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex justify-center lg:justify-end">
            <img
              src={illustration}
              alt="Tracking illustration"
              className="w-full max-w-[360px] sm:max-w-[420px] md:max-w-[480px] lg:max-w-[400px]"
            />
          </div>
        </div>
      </section>

      <div className="bg-white text-center px-6 py-16 md:px-12">
        <h2 className="text-3xl md:text-5xl font-medium text-[#1A1A1A] leading-snug mb-6">
          Tracking encouraging operational <br className="hidden md:block" />
          excellence
        </h2>
        <p className="text-gray-600 text-[12px] md:text-[15px] max-w-3xl mx-auto">
          Tracking promotes operational excellence by providing real-time data for smarter <br />  decisions.
          It enhances efficiency, accuracy and responsiveness across the supply chain.
        </p>
      </div>
      <div className="relative bg-white py-16 px-4 sm:px-8 lg:px-20 overflow-hidden -mt-10">
        {/* Background shapes */}

        <div className="relative z-10 mx-auto grid max-w-4xl gap-8 md:grid-cols-2">
          {/* 1 — from left */}
          <motion.div
            className="w-[285px] h-[259px] ml-[120px]"
            variants={variants}
            initial="hiddenLeft"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
          >
            <FeatureCard
              title="Tracking solutions"
              items={[
                "Commitment to innovation & technology",
                "Reliable tracking solutions",
                "Improved supply chain visibility & efficiency",
                "Enhanced customer satisfaction",
              ]}
              bgColor="bg-rose-100"
              dotColor="bg-rose-400"
            />
          </motion.div>

          {/* 2 — from top */}
          <motion.div
            className="w-[408px] h-[218px]"
            variants={variants}
            initial="hiddenUp"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
          >
            <FeatureCard
              title="Empowering operational efficiency"
              items={[
                "Accurate and reliable optimization of logistics operations",
                "Real-time shipment status analytics",
                "Proactive decision-making support",
                "Prompt action to minimize disruptions",
              ]}
              bgColor="bg-purple-200"
              dotColor="bg-purple-500"
            />
          </motion.div>

          {/* 3 — from bottom */}
          <motion.div
            className="w-[408px] h-[218px]"
            variants={variants}
            initial="hiddenDown"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
          >
            <FeatureCard
              title="Dedication to Superiority"
              items={[
                "Commitment to innovation, scalability and dependability",
                "Pursuit of operational excellence",
                "Ability to foresee market trends and tackle new challenges",
                "Establishing as a reliable partner in global supply chain optimization",
              ]}
              bgColor="bg-yellow-100"
              dotColor="bg-yellow-400"
            />
          </motion.div>

          {/* 4 — from right */}
          <motion.div
            className="w-[285px] h-[259px]"
            variants={variants}
            initial="hiddenRight"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
          >
            <FeatureCard
              title="Client centric approach"
              items={[
                "Ensure fulfillment of demanding delivery deadlines",
                "Provide clients with precise arrival times",
                "Quickly handle logistical issues",
                "Support reliable tracking through advanced systems",
              ]}
              bgColor="bg-green-100"
              dotColor="bg-green-400"
            />
          </motion.div>
        </div>
      </div>

      <section className="bg-[#FFF2B2] py-20 px-4 sm:px-6 lg:px-12">
        {/* Section Heading */}
        <div className="max-w-6xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Key drivers of transformation
          </h2>
          <p className="mt-4 text-gray-700 max-w-2xl mx-auto text-base md:text-lg">
            Several key factors are driving the transformation of logistics,
            including technological advances, market demands and evolving customer
            expectations.
          </p>
        </div>

        {/* Grid Cards */}
        <div className="flex flex-wrap justify-center gap-6">
          {transformationDrivers.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-3xl shadow-sm p-6 flex flex-col justify-start w-[520px] h-[237px]"
            >
              <img src={item.icon} alt={item.title} className="w-12 h-12 mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

          {/* Left side: Text + Image */}
          <div className="w-full lg:w-[48%] relative flex flex-col items-center lg:items-start text-center lg:text-left">
            <h2 className="text-[28px] sm:text-[36px] md:text-[44px] font-semibold text-[#1E1E1E] leading-tight mb-6">
              Significantly impact by the logistics transformation
            </h2>
            <p className="text-[#4B5563] text-[16px] sm:text-[18px] leading-[28px] mb-10 max-w-[600px]">
              Logistics transformation is driving major improvements in speed, accuracy and efficiency across supply chains. It significantly impacts how businesses operate, compete and deliver value to customers.
            </p>

            {/* Responsive Background Circle (optional) */}
            <div className="absolute top-[50%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] sm:w-[320px] md:w-[400px] h-auto opacity-20 pointer-events-none z-0">
              {/* <img
              src={bgCircle}
              alt=""
              className="w-full h-auto"
            /> */}
            </div>

            {/* Main Logistics Image */}
            <div className="relative z-10 w-full max-w-[400px] sm:max-w-[460px] md:max-w-[500px] mx-auto lg:mx-0 flex justify-center items-center">
              <img
                src={logisticsImg}
                alt="Logistics"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Right side: Animated cards */}
          <div className="w-full lg:w-[50%] flex flex-col gap-6">
            {logisticsBenefits.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: false, amount: 0.4 }}
                className="bg-[#F4F9FF] p-5 sm:p-6 rounded-[20px] shadow-sm"
              >
                <h3 className="text-[18px] sm:text-[20px] font-semibold text-[#1E1E1E] mb-2">
                  {item.title}
                </h3>
                <p className="text-[#4B5563] text-[15px] sm:text-[16px] leading-[24px] sm:leading-[26px]">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Logistics